//#region src/expo_printer_mode.ts
var ExpoPrinterMode = /* @__PURE__ */ function(ExpoPrinterMode) {
	ExpoPrinterMode["PrintOnlySentOrders"] = "print-only-sent-orders";
	ExpoPrinterMode["PrintOnlyOnDemandOrders"] = "print-only-on-demand-orders";
	ExpoPrinterMode["PrintAllOrders"] = "print-all-orders";
	return ExpoPrinterMode;
}(ExpoPrinterMode || {});
//#endregion
export { ExpoPrinterMode };

//# sourceMappingURL=expo_printer_mode.js.map